import { render, staticRenderFns } from "./PopupTemplateForm.vue?vue&type=template&id=74e95032"
import script from "./PopupTemplateForm.vue?vue&type=script&lang=js"
export * from "./PopupTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports